import { AuxiliaryEngineMaker } from './AuxiliaryEngineMaker';

export class AuxiliaryEngineType {
    id: number;
    type: string;
    makerId: number;
    maker: AuxiliaryEngineMaker;
    kwMaxLoad?: number;
    canUseHfo?: boolean;

    constructor(id: number, type: string, makerId: number, maker: AuxiliaryEngineMaker, kwMaxLoad?: number, canUseHfo?: boolean) {
        this.id = id;
        this.type = type;
        this.makerId = makerId;
        this.maker = maker;
        this.kwMaxLoad = kwMaxLoad;
        this.canUseHfo = canUseHfo;
    }
}
